import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import { useAppContext } from 'providers/AppProvider';
import { TooltipComponent, TitleComponent, LegendComponent, ToolboxComponent } from 'echarts/components';
import { PieChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import { rgbaColor } from 'helpers/utils';
import { useEffect, useRef, useState } from 'react';
import { usePowerStationFilterStore } from '../stores/PowerStationFilterStore';

import { getDeadlineLabels } from '../Utils';
import dayjs from 'dayjs';

echarts.use([TooltipComponent, TitleComponent, LegendComponent, ToolboxComponent, PieChart, CanvasRenderer]);


const ExecutionAnomaliesDealinesChart = () => {
	const { getThemeColor } = useAppContext();
	const chartRef = useRef(null);
	const dataDeadline = getDeadlineLabels();

	const activeAnomalyRecords = usePowerStationFilterStore((state) => state.activeAnomalyRecords);
	const deadlineFilter = usePowerStationFilterStore((state) => state.deadlineFilter);
	const filterActiveAnomalyRecordsByDeadline = usePowerStationFilterStore((state) => state.filterActiveAnomalyRecordsByDeadline);

	const setSeriesData = () => {
		let expired = 0;
		let near = 0;
		let farAway = 0;

		const now = Date.now();

		const activeAnomalyRecordsFiltered = activeAnomalyRecords.filter(x => !x.finished)


		activeAnomalyRecordsFiltered.forEach(item => {
			const deadlineExecution = item.deadlineExecution ? dayjs(item.deadlineExecution) : null; // Ensure it's a Dayjs instance
			if (!deadlineExecution) {
				return; // Skip this item if deadlineExecution is undefined
			}

			const diffDays = (deadlineExecution.toDate().getTime() - now) / (1000 * 60 * 60 * 24);

			if (diffDays < 0) {
				expired++;
			} else if (diffDays <= 30) {
				near++;
			} else {
				farAway++;
			}
		});

		return [
			{ value: expired, name: dataDeadline[0] },
			{ value: near, name: dataDeadline[1] },
			{ value: farAway, name: dataDeadline[2] },
		];
	};

	const seriesData = setSeriesData();


	const getDefaultOptions = (getThemeColor: (name: string) => string) => {
		const selected: Record<string, boolean> = {};
		seriesData.forEach(item => {
			selected[item.name] = item.value > 0;
		});

		return {
			color: [
				'rgba(255, 0, 0, 0.7)',
				'rgba(255, 255, 0, 0.5)',
				'rgba(0, 255, 0, 0.5)',
			],
			// title: {
			//   text: 'Prazo de Monitoramento',
			//   left: 'center',
			//   top: '10%'
			// },
			legend: {
				data: dataDeadline,
				bottom: '0px',
				left: '0px',
				orient: 'vertical',
				align: 'left',
				textStyle: {
					color: getThemeColor('gray-800'),
					fontSize: 12
				},
				selected: selected
			},
			toolbox: {
				show: true,
				feature: {
					restore: {
						show: deadlineFilter.length > 0,
						title: 'Limpar filtro',
						// iconStyle: {
						// 	borderColor: 'blue' // se o ícone for em linha
						// },
						// emphasis: {
						// 	iconStyle: {
						// 		borderColor: 'blue'
						// 	}
						// }
					},
				}
			},
			series: [
				{
					type: 'pie',
					radius: '50%',
					center: ['50%', '40%'],
					label: {
						formatter: (params: { value: number; }) => {
							return ((params.value / total) * 100).toFixed(1) + '%';
						},
						color: getThemeColor('gray-700')
					},
					data: seriesData,
					emphasis: {
						itemStyle: {
							shadowBlur: 10,
							shadowOffsetX: 0,
							shadowColor: rgbaColor(getThemeColor('gray-600'), 0.5)
						}
					}
				}
			],
			tooltip: {
				trigger: 'item',
				padding: [7, 10],
				backgroundColor: getThemeColor('gray-100'),
				borderColor: getThemeColor('gray-300'),
				textStyle: { color: getThemeColor('gray-1100') },
				borderWidth: 1,
				transitionDuration: 0,
				axisPointer: {
					type: 'none'
				}
			}
		};
	}

	// Calcula o total para percentuais
	const total = seriesData.reduce((sum, item) => sum + item.value, 0);

	const handleClick = (params: any) => {
		filterActiveAnomalyRecordsByDeadline([params.name]);
	}

	const handleLegendClick = (params: any) => {
		const selectedMap = params.selected;
		const activeLegends = Object.keys(selectedMap).filter(name => selectedMap[name]);
		filterActiveAnomalyRecordsByDeadline(activeLegends);
	};

	const handleRestore = (params: any) => {
		filterActiveAnomalyRecordsByDeadline([]);
	}

	return (
		<ReactEChartsCore
			echarts={echarts}
			option={getDefaultOptions(getThemeColor)}
			style={{ minHeight: '350px', width: '100%' }}
			ref={chartRef}
			onEvents={{
				click: handleClick,
				legendselectchanged: handleLegendClick,
				restore: handleRestore
			}}
		/>
	);
};

export default ExecutionAnomaliesDealinesChart;
